<template>
  <div id="userManage">
    <b>AWSアカウント同期画面</b><br/><br/>

    <table class="table icon">
      <tr>
        <td>AWSアカウント同期用画面です。</td>
      </tr>
    </table><br/>
    AWS同期 <br/><br/>
    同期用ユーザ：<br/><br/><input type="text" placeholder="ユーザＩＤ" v-model="awsMemberID"><br/><br/>
    同期用パスワード：<br/><br/><input type="password" placeholder="パスワード" v-model="awsPassword"><br/><br/>
    <button v-on:click="syncAws" class="btn-mid" style="width:250px;">AWS同期</button>&nbsp;
    <button @click="$router.back(-1);" class="btn-mid" style="width:250px;">キャンセル</button><br/>
    <div class="bootstrap-table fixed-table-container" style="margin-bottom:10px;margin-bottom:10px;width: 100%;">
        <table id="rptHeader" class="table table-striped">
          <thead>
            <tr >
              <td>同期結果:</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in syncResultMessages" v-bind:key="'row' + index">
              <td>{{ row }}</td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>
</template>

<script>
  export default {
    name: "userManage",
    data() {
      return {
          syncResultMessages: [ ],
      }
    },
    methods: {
      syncAws: function () {
        var self = this;

        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = { awsMemberID: self.awsMemberID, awsPassword: self.awsPassword };
          common.getAxios().post(process.env.API_URL +"/api/SyncAWS", data)
            .then(function (res) {
              // 処理正常の場合
              if (res.data.messages.length>0) {
                self.syncResultMessages = res.data.messages
              }
              // 処理エラーの場合
              else {
                alert("エラー発生。");
              }
            })
            .catch(function (err) {
              alert(err);
            });
        });
      },

    }
  };
</script>



// WEBPACK FOOTER //
// syncAWS.vue?6d2a04cb